import { Component, OnInit } from '@angular/core';
import { CognitoService } from '../../../shared';

@Component({
  selector: 'app-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
})
export class SignOutComponent implements OnInit {
  constructor(private cognitoService: CognitoService) {}

  ngOnInit() {
    this.init();
  }

  private async init() {
    await this.cognitoService.signOut();
  }
}
